import React, { useEffect } from "react";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";

const values = [
  {
    title: "Innovation",
    description: "We constantly push the boundaries of digital possibilities, staying ahead of trends to give you a competitive edge.",
    icon: "💡"
  },
  {
    title: "Integrity",
    description: "Transparency and honesty are the foundation of our partnerships. We treat your business as our own.",
    icon: "🤝"
  },
  {
    title: "Impact",
    description: "We don't just deliver reports; we deliver results that move the needle and drive measurable growth.",
    icon: "📈"
  }
];

function About() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-container">
          <span className="accent-tag" data-aos="fade-up">Who We Are</span>
          <h1 data-aos="fade-up" data-aos-delay="100">
            Driving Digital <span className="highlight">Transformation</span>
          </h1>
          <p className="about-subtitle" data-aos="fade-up" data-aos-delay="200">
            Cabptoid Solutions is a premier digital marketing agency dedicated to scaling brands in the modern digital era. We blend creativity with data-driven strategies.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="about-mission">
        <div className="about-container grid">
          <div className="mission-card" data-aos="fade-right">
            <h2>Our Mission</h2>
            <p>To empower businesses by unlocking their full digital potential through innovative marketing solutions and strategic excellence.</p>
          </div>
          <div className="mission-card" data-aos="fade-left">
            <h2>Our Vision</h2>
            <p>To be the world's most trusted partner for digital growth, recognized for our commitment to performance, transparency, and transformative results.</p>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="about-values">
        <div className="about-container">
          <div className="section-header" data-aos="fade-up">
            <span className="accent-tag">The Foundation</span>
            <h2>Our Core <span className="highlight">Values</span></h2>
          </div>
          <div className="values-grid">
            {values.map((val, index) => (
              <div 
                className="value-card" 
                key={index}
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                <div className="value-icon">{val.icon}</div>
                <h3>{val.title}</h3>
                <p>{val.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Cabptoid? */}
      <section className="about-story">
        <div className="about-container">
          <div className="story-content" data-aos="fade-up">
            <h2>Why <span className="highlight">Cabptoid?</span></h2>
            <p>
              In a crowded digital world, we stand out by being more than just a service provider. We are your strategic partners. Our team of experts brings years of experience across SEO, PPC, Social Media, and E-commerce to ensure your brand doesn't just exist online—it dominates.
            </p>
            <div className="story-cta">
              <a href="#contact" className="cta-button">Let's Build Your Story</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
